import script from "./LtcsRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtcsRequestModal.vue?vue&type=script&setup=true&lang=ts"

import "./LtcsRequestModal.vue?vue&type=style&index=0&id=3c4feca0&lang=scss"

const __exports__ = script;

export default __exports__